import { dialog } from '@rynpsc/dialog';

export function create(element) {
	if (!element) {
		return;
	}

	const openers = Array.from(document.querySelectorAll('.js-montage-open'));
	const closers = Array.from(document.querySelectorAll('.js-montage-close'));

	const dialogInstance = dialog(element.id);
	dialogInstance.create();

	const items = Array.from(element.querySelectorAll('.js-montage-item'));

	openers.forEach(elem => elem.addEventListener('click', () => dialogInstance.open()));
	closers.forEach(elem => elem.addEventListener('click', () => dialogInstance.close()));

	function open(index = 0) {
		console.log(index);
		dialogInstance.open();
	}

	dialogInstance.on('open', () => {
		element.scrollTop = 0;

		let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.body.style.overflow = 'hidden';
		document.body.style.paddingRight = `${scrollbarWidth}px`;
	});

	dialogInstance.on('close', () => {
		dialogInstance.element.addEventListener('transitionend', onTransitionEnd);
	});

	function onTransitionEnd(event) {
		if (event.propertyName !== 'opacity') {
			return;
		}

		document.body.style = '';
		document.body.style.paddingRight = '';

		dialogInstance.element.removeEventListener('transitionend', onTransitionEnd);
	}

	return { open, items };
}
